import { AnyAction, Reducer } from "redux";

export const composeReducers =
  <S, A extends AnyAction = AnyAction>(...reducers: Array<Reducer<S, A>>): Reducer<S, A> =>
  (s, action) =>
    reducers.reduce((state, reducer) => reducer(state, action), s)!;
